import styled from 'styled-components'

const DropdownItemContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

export default DropdownItemContent